// // src/components/FAQsSection.jsx
// import React, { useState } from "react";
// import { FaPlus, FaMinus } from "react-icons/fa";
// import { motion } from 'framer-motion';
// const FAQsSectionApartment = () => {
//   const [openIndex, setOpenIndex] = useState(null);

//   const toggleFAQ = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   const faqs = [
//     {
//       question: "Is WiFi included in the rent?",
//       answer:
//         "Yes, complimentary high-speed WiFi (100 Mbps) is included in all our apartments.",
//     },
//     {
//       question: "What are the check-in and check-out timings?",
//       answer: "Check-in time is 2:00 PM and check-out is 12:00 PM.",
//     },
//     {
//       question: "Is housekeeping service provided?",
//       answer: "Yes, we provide complimentary housekeeping twice a week.",
//     },
//     {
//       question: "Can I bring guests?",
//       answer:
//         "Yes, daytime guests are allowed. Overnight guests must be registered.",
//     },
//     {
//       question: "Is parking available?",
//       answer: "Yes, secure covered parking is available.",
//     },
//   ];

//   return (
//     <section className="py-12 bg-gradient-to-b from-[#f1f1f1] via-[#f1f1f1]/0 to-[#f1f1f1]/0">
//       <div className="container-custom grid lg:grid-cols-2 gap-8 md:gap-16 items-end">

//         {/* LEFT CONTENT */}
//         <div className="space-y-4">

//           {/* Small Label */}
//            <div className="flex items-center gap-3">
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//             <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
//              FAQ
//             </span>
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//           </div>

//           {/* Title */}
//           <h2 className="text-4xl md:text-5xl font-light text-[#1a2b3c] leading-tight">
//             Got Questions? <br />
//             <span className="font-bold text-[#c9a86c]">
//               We’ve Got Answers!
//             </span>
//           </h2>

//           {/* FAQ LIST */}
//           <div className="space-y-4">
//             {faqs.map((faq, index) => (
//               <div
//                 key={index}
//                 className="p-1 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 hover:border-gray-100"
//               >
//                 <button
//                   onClick={() => toggleFAQ(index)}
//                   className="w-full flex justify-between items-center px-6 py-4 text-left"
//                 >
//                   <span className="2xl:text-lg text-[15px] text-gray-700 font-medium">
//                     {faq.question}
//                   </span>

//                   <div className="w-8 h-8 rounded-full bg-[#c9a86c]/10 flex items-center justify-center">
//                     {openIndex === index ? (
//                       <FaMinus className="text-[#c9a86c] text-sm" />
//                     ) : (
//                       <FaPlus className="text-[#c9a86c] text-sm" />
//                     )}
//                   </div>
//                 </button>

//                 {openIndex === index && (
//                    <motion.div
//                                     initial={{ opacity: 0, height: 0 }}
//                                     animate={{ opacity: 1, height: "auto" }}
//                                     exit={{ opacity: 0, height: 0 }}
//                                     transition={{ duration: 0.3 }}
//                                     className="px-6 py-4 border-t border-gray-100"
//                                   >
//                   <div className="flex items-start gap-4">
//                   {/* <div className="w-8 h-8 flex-shrink-0"></div> Spacer for alignment */}
//                     <div className="flex-1">
//                       <p className="text-gray-600 text-sm md:text-base leading-relaxed">
//                         {faq.answer}
//                       </p>
//                     </div>
//                   </div>
//                   </motion.div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* RIGHT SIDE */}
//         <div className='space-y-4'>

//           {/* Description */}
//           <p className="md:text-[17px] 2xl:text-lg text-gray-600 leading-relaxed">
//             Find everything you need to know about your stay at StayIN
//             Centaurus. From check-in details to amenities and services,
//             we’ve covered it all.
//           </p>

//           {/* Image */}
//           <div className="rounded-2xl overflow-hidden shadow-xl">
//             <img
//               src="https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-19-59-41_gyletw.jpg"
//               alt="Apartment"
//               className="w-full h-[420px] object-cover"
//             />
//           </div>

//         </div>

//       </div>
//     </section>
//   );
// };

// export default FAQsSectionApartment;


// src/components/FAQsSection.jsx
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { FaPlus, FaMinus } from "react-icons/fa";
import { motion } from 'framer-motion';

const FAQsSectionApartment = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "Is WiFi included in the rent?",
      answer: "Yes, complimentary high-speed WiFi (100 Mbps) is included in all our apartments.",
    },
    {
      question: "What are the check-in and check-out timings?",
      answer: "Check-in time is 2:00 PM and check-out is 12:00 PM.",
    },
    {
      question: "Is housekeeping service provided?",
      answer: "Yes, we provide complimentary housekeeping twice a week.",
    },
    {
      question: "Can I bring guests?",
      answer: "Yes, daytime guests are allowed. Overnight guests must be registered.",
    },
    {
      question: "Is parking available?",
      answer: "Yes, secure covered parking is available.",
    },
  ];

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>FAQs | StayIN Centaurus Serviced Apartments Islamabad</title>
        <meta name="description" content="Find answers to common questions about StayIN Centaurus serviced apartments. Learn about WiFi, check-in times, housekeeping, parking, and more. Your guide to luxury stays in Islamabad." />
        <meta name="keywords" content="StayIN FAQs, Centaurus Islamabad questions, serviced apartments rules, check-in timings, housekeeping service, parking Centaurus" />
      </Helmet>

      {/* FAQ Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>

      <section className="py-12 bg-gradient-to-b from-[#f1f1f1] via-[#f1f1f1]/0 to-[#f1f1f1]/0" aria-label="Frequently asked questions about StayIN Centaurus apartments">
        <div className="container-custom grid lg:grid-cols-2 gap-8 md:gap-16 items-end">

          {/* LEFT CONTENT */}
          <div className="space-y-4">

            {/* Small Label */}
            <div className="flex items-center gap-3">
              <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
              <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
                FAQ
              </span>
              <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
            </div>

            {/* Title */}
            <h2 className="text-4xl md:text-5xl font-light text-[#1a2b3c] leading-tight">
              Got Questions? <br />
              <span className="font-bold text-[#c9a86c]">
                We’ve Got Answers!
              </span>
            </h2>

            {/* FAQ LIST */}
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="p-1 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 hover:border-gray-100"
                >
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="w-full flex justify-between items-center px-6 py-4 text-left"
                    aria-expanded={openIndex === index}
                    aria-controls={`faq-answer-${index}`}
                  >
                    <span className="2xl:text-lg text-[15px] text-gray-700 font-medium">
                      {faq.question}
                    </span>

                    <div className="w-8 h-8 rounded-full bg-[#c9a86c]/10 flex items-center justify-center">
                      {openIndex === index ? (
                        <FaMinus className="text-[#c9a86c] text-sm" aria-hidden="true" />
                      ) : (
                        <FaPlus className="text-[#c9a86c] text-sm" aria-hidden="true" />
                      )}
                    </div>
                  </button>

                  {openIndex === index && (
                    <motion.div
                      id={`faq-answer-${index}`}
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3 }}
                      className="px-6 py-4 border-t border-gray-100"
                    >
                      <div className="flex items-start gap-4">
                        <div className="flex-1">
                          <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                            {faq.answer}
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className='space-y-4'>

            {/* Description */}
            <p className="md:text-[17px] 2xl:text-lg text-gray-600 leading-relaxed">
              Find everything you need to know about your stay at StayIN
              Centaurus. From check-in details to amenities and services,
              we’ve covered it all.
            </p>

            {/* Image */}
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-19-59-41_gyletw.jpg"
                alt="Luxury serviced apartment interior at StayIN Centaurus Islamabad"
                className="w-full h-[420px] object-cover"
              />
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default FAQsSectionApartment;